import { RootPaths } from "@src/appV2/App/paths";

export const NOTIFICATIONS_PREFERENCE_PATH = "account/notification-preference";
export const NOTIFICATIONS_PREFERENCE_PATH_FULL = `${RootPaths.APP_V2_HOME}/${NOTIFICATIONS_PREFERENCE_PATH}`;
